import React from "react";
import "./Footer.css";
import { HiArrowSmUp } from "react-icons/hi";
import logo from '../../assets/img/footer/logo.png'
import {Link} from "react-router-dom";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__grid">
          <a className="footer-logo-box" href="/">
            <img
              src={logo}
              alt="Logo"
              className='footer-logo'
            />
          </a>
          <div className="footer-links">
            <Link to='/' className="footer-link">Home</Link>
            <Link to='/about-us' className='footer-link'>About Us</Link>
            <Link to='/player-support' className='footer-link'>Player Support</Link>
            <Link to='/file-complaint' className='footer-link'>File Complaint</Link>
            <Link to='/license-support-services' className='footer-link'>License Support Services</Link>
            <Link to='/license-register' className='footer-link'>License Register</Link>
          </div>


          <div >
            <Link to='/contact-us'  className="btn">
              Contact Us               <HiArrowSmUp/>
            </Link>

            <p className="footer-copyright">
              © AOFA. All Rights Reserved
            </p>
          </div>


        </div>

      </div>
    </footer>

  );
};

export default Footer;
